var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticClass:"screeningCriteria",on:{"click":_vm.onMoreFilter}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),(!_vm.isMoreFilter)?_c('a-icon',{style:({ transform: 'rotate(90deg)' }),attrs:{"type":"double-right"}}):_vm._e(),(_vm.isMoreFilter)?_c('a-icon',{style:({ transform: 'rotate(-90deg)' }),attrs:{"type":"double-right"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }